(function ($) {
  function syncStickyToolbarCartCount(count) {
    var itemCount = typeof count === 'number' ? count : 0;
    document.querySelectorAll('[data-sticky-toolbar-cart-count]').forEach(function (el) {
      el.textContent = String(itemCount);
      el.hidden = itemCount <= 0;
    });
    document.querySelectorAll('.sticky-toolbar-mobile__item--cart').forEach(function (cartLink) {
      var label = cartLink.querySelector('.sticky-toolbar-mobile__label');
      var labelText = label ? label.textContent.trim() : 'Cart';
      cartLink.setAttribute('aria-label', labelText + ' (' + itemCount + ')');
    });
  }

  function refreshStickyToolbarCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          syncStickyToolbarCartCount(cart.item_count);
        }
      })
      .catch(function () {});
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail;
    if (cart && typeof cart.item_count === 'number') {
      syncStickyToolbarCartCount(cart.item_count);
    }
  });

  document.documentElement.addEventListener('theme:cartchanged', refreshStickyToolbarCartCount);

  function syncStickyToolbarWishlistCount(count) {
    var itemCount = typeof count === 'number' ? count : 0;
    document.querySelectorAll('[data-sticky-toolbar-wishlist-count]').forEach(function (el) {
      el.textContent = String(itemCount);
      el.hidden = itemCount <= 0;
    });
    document.querySelectorAll('.sticky-toolbar-mobile__item--wishlist.header-wishlist-link').forEach(function (trigger) {
      var label = trigger.querySelector('.sticky-toolbar-mobile__label');
      var labelText = label ? label.textContent.trim() : 'Wishlist';
      trigger.setAttribute('aria-label', itemCount > 0 ? labelText + ' (' + itemCount + ')' : labelText);
    });
  }

  document.addEventListener('wishlist:updated', function (event) {
    var handles = event && event.detail && event.detail.handles;
    if (Array.isArray(handles)) {
      syncStickyToolbarWishlistCount(handles.length);
    } else if (window.PureWishlist && typeof window.PureWishlist.refresh === 'function') {
      window.PureWishlist.refresh();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === 'pure-wishlist-handles' && window.PureWishlist && typeof window.PureWishlist.refresh === 'function') {
      window.PureWishlist.refresh();
    }
  });

  $(document).on('click', '.sticky-toolbar-mobile__action--search', function (e) {
    e.preventDefault();
    if ($('body').toggleClass('show-search').hasClass('show-search')) {
      setTimeout(function () {
        $('.main-search__input:first').focus();
      }, 500);
      $('.main-search__suggestions .lazyload--manual').removeClass('lazyload--manual').addClass('lazyload');
    } else {
      $('.show-search-link:first').focus();
    }
    return false;
  });
})(jQuery);
